import { Content } from 'src/contexts/ContentContext';
import { PosFormField } from 'src/core/POS/PosFormField';
import { PosSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';

export type CitySelectProps = {
  value: string;
  options: Record<string, string>;
  onChange: (value: string) => void;
  loading?: boolean;
  disabled?: boolean;
};

export function CitySelect({
  value,
  options,
  onChange,
  loading,
  disabled,
}: CitySelectProps) {
  return (
    <PosFormField label={<Content id={ContentId.City} />}>
      <PosSelect
        style={{ width: '100%' }}
        valueOptionsContent={options}
        value={value}
        onChange={onChange}
        placeholderText={ContentId.SelectCity}
        loading={loading}
        disabled={disabled}
        searchable
        enableEmptySelection
      />
    </PosFormField>
  );
}
